import { fetchPurchaseSchedules, selectPurchaseSchedule, resetCurrentPurchaseSchedule } from '../../actions/purchaseSchedules_actions';
import { connect } from 'react-redux';

import PurchaseScheduleList from '../../components/Purchase/purchaseScheduleList'

function mapStateToProps(state) {
    return {
        currentPurchaseSchedule: state.purchaseSchedules.currentPurchaseSchedule,
        purchaseSchedules: state.purchaseSchedules.all,
        isLoading: state.purchaseSchedules.isLoading,
        error: state.purchaseSchedules.error,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { fetchPurchaseSchedules, selectPurchaseSchedule, resetCurrentPurchaseSchedule })(PurchaseScheduleList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseScheduleList.jsx